import { FC } from 'react'
import styled from 'styled-components'
import { Close } from 'svgIcons'
import Button from '@app.components/Button'
import Modal from '@app.components/Modal'
import { IFModalProps } from '@app.components/Modal/Modal'
import { mobileBreakPoint } from 'app.styled/media'

interface IFScrapDeleteAllModalProps extends IFModalProps {
  onConfirm: () => void
}

const ScrapDeleteAllModal: FC<IFScrapDeleteAllModalProps> = (props) => {
  return (
    <Modal {...props}>
      <StyledWrapper>
        <div className="content-wrapper">
          <div className="close-button" onClick={props.onClose}>
            <Close style={{ width: '16px', color: '#333' }} />
          </div>
          {props.children}
          <div className="button-container">
            <Button className="candle-button" onClick={props.onClose}>
              아니요
            </Button>
            <Button className="button" onClick={props.onConfirm}>
              삭제하기
            </Button>
          </div>
        </div>
      </StyledWrapper>
    </Modal>
  )
}

export default ScrapDeleteAllModal

const StyledWrapper = styled.div`
  max-width: 450px;
  width: 100%;
  min-height: 245px;
  background-color: white;
  justify-content: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 20px;

  ${mobileBreakPoint} {
    max-width: 340px;
  }

  .close-button {
    position: absolute;
    right: 8px;
    top: 8px;
    padding: 12px;
  }

  .content-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 254px;
    position: relative;
  }

  .button-container {
    padding: 0px 30px;
    width: 100%;
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 40px;
    gap: 8px;
  }

  .button,
  .candle-button {
    font-size: 16px;
    width: 100%;
    height: 50px;
  }

  .candle-button {
    background-color: #eeeeee;
    color: #333333;
    &:hover {
      background-color: #d5d5d5;
    }
  }
`
